import {Component} from '@angular/core';

@Component({
    selector: 'app-privacypolicy',
    templateUrl: './privacypolicy.component.html',
    styleUrls: ['./privacypolicy.component.css']
})
export class PrivacypolicyComponent {
}
